import React from "react";

import
{
    faMagnifyingGlass
}
from "@fortawesome/free-solid-svg-icons";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";


export default function SearchHeader(
{
    placeholder,
    value,
    onChange,
    count,
    label
})
{

    return (

        <div

            style={{

                display:
                    "flex",

                alignItems:
                    "center",

                gap:
                    "14px",

                padding:
                    "18px 20px",

                borderBottom:
                    "1px solid rgba(255,255,255,.08)"
            }}

        >

            {/* ------------------------------------------------
                Search
                ------------------------------------------------ */}

            <div

                style={{

                    position:
                        "relative",

                    flex:
                        1
                }}

            >

                <FontAwesomeIcon

                    icon={faMagnifyingGlass}

                    style={{

                        position:
                            "absolute",

                        left:
                            "16px",

                        top:
                            "50%",

                        transform:
                            "translateY(-50%)",

                        color:
                            "#42bff5",

                        pointerEvents:
                            "none",

                        fontSize:
                            "14px"
                    }}

                />


                <input

                    value={value}

                    placeholder={placeholder}

                    onChange={(e) =>
                        onChange(e.target.value)
                    }

                    style={{

                        width:
                            "100%",

                        height:
                            "42px",

                        boxSizing:
                            "border-box",

                        padding:
                            "0 18px 0 42px",

                        borderRadius:
                            "0px",

                        border:
                            "1px solid rgba(255,255,255,.10)",

                        background:
                            "linear-gradient(" +
                            "180deg, " +
                            "rgba(255,255,255,.06) 0%, " +
                            "rgba(255,255,255,.035) 100%" +
                            ")",

                        color:
                            "white",

                        fontSize:
                            "14px",

                        outline:
                            "none",

                        boxShadow:
                            "inset 0 1px 0 rgba(255,255,255,.025)",

                        transition:
                            ".25s"
                    }}

                />

            </div>


            {/* ------------------------------------------------
                Result count
                ------------------------------------------------ */}

            <div

                style={{

                    minWidth:
                        "90px",

                    height:
                        "42px",

                    padding:
                        "0 18px",

                    boxSizing:
                        "border-box",

                    borderRadius:
                        "0px",

                    display:
                        "flex",

                    alignItems:
                        "center",

                    justifyContent:
                        "center",

                    background:
                        "linear-gradient(" +
                        "180deg, " +
                        "#42bff5 0%, " +
                        "#159bd7 100%" +
                        ")",

                    border:
                        "1px solid rgba(66,191,245,.35)",

                    color:
                        "white",

                    fontWeight:
                        600,

                    boxShadow:
                        "0 4px 12px rgba(21,155,215,.22)",

                    transition:
                        "all .3s ease"
                }}

            >

                <span

                    style={{

                        fontSize:
                            "15px",

                        fontWeight:
                            700
                    }}

                >

                    {count}

                </span>


                <span

                    style={{

                        marginLeft:
                            "6px",

                        fontSize:
                            "13px",

                        opacity:
                            .9
                    }}

                >

                    {label}

                </span>

            </div>

        </div>

    );

}